module.exports = __webpack_public_path__ + "static/how-its-work-8d04d82e5306574879c11a95b0209547.png";